import { z } from 'zod/v4';

export const PatchCompanyDocumentParamsSchema = z.object({
  id: z.string().min(1),
});

export type PatchCompanyDocumentParams = z.infer<
  typeof PatchCompanyDocumentParamsSchema
>;

/**
 * Both fields are optional, and an omitted or `null` one keeps what the document
 * already has — a `null` cannot clear a name or a type, and an empty string is
 * rejected. The
 * body is kept exactly that permissive so the frontends' payloads still validate;
 * an empty body is a valid no-op that still stamps who touched the document.
 *
 * The 255s are the `company_documents` column widths (`name` and
 * `document_type_id` are `varchar(255)`), so an oversized value answers 400
 * instead of a database error.
 */
export const PatchCompanyDocumentBodySchema = z.strictObject({
  name: z.string().min(1).max(255).nullable().optional(),
  documentTypeId: z.string().min(1).max(255).nullable().optional(),
});

export type PatchCompanyDocumentBody = z.infer<
  typeof PatchCompanyDocumentBodySchema
>;
